import { AxiosInstance } from "axios";
import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CommuneListRequestBody, CommuneListResponse } from "./types";

export class CommuneListAPI extends BaseAPI<
  CommuneListRequestBody,
  CommuneListResponse
> {
  protected route = ApiRoutes.property.commune;
  protected method = RequestMethod.GET;

  constructor(axios: AxiosInstance, district_id: string) {
    super(axios);
    this.route = ApiRoutes.property.commune.replace("{district_id}", district_id);
  }
}
